/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as externalCartActionTypes from './ExternalCart-ActionTypes';

export const getExternalCartItems = (data) => ({
    type: externalCartActionTypes.GET_EXTERNALCART_ITEMS,
    data,
});

export const setExternalCartItems = (data) => ({
    type: externalCartActionTypes.SET_EXTERNALCART_ITEMS,
    data,
});

export const setExternalCartError = (data) => ({
    type: externalCartActionTypes.SET_EXTERNALCART_ITEM_ERROR,
    data,
});

export const loadExternalCartError = (error) => ({
    type: externalCartActionTypes.LOAD_EXTERNALCART_ITEM_ERROR,
    data: {
        error,
    },
});

export const clearExternalCartItemsErrors = () => ({
    type: externalCartActionTypes.CLEAR_EXTERNALCART_ITEM_ERROR,
});

export const getExternalCartAccessToken = (data) => ({
    type: externalCartActionTypes.GET_EXTERNALCART_ACCESS_TOKEN,
    data,
});

export const setExternalCartAccessToken = (data) => ({
    type: externalCartActionTypes.SET_EXTERNALCART_ACCESS_TOKEN,
    data,
});

export const getExternalCartDTW = (data) => ({
    type: externalCartActionTypes.GET_EXTERNALCART_DTW,
    data,
});

export const setExternalCartDTWById = (data) => ({
    type: externalCartActionTypes.SET_EXTERNALCART_DTW_BY_ID,
    data,
});

export const externalCartAddToCart = (data) => ({
    type: externalCartActionTypes.EXTERNALCART_ADD_TO_CART,
    data,
});

export const externalCartAddToCartError = (data) => ({
    type: externalCartActionTypes.EXTERNALCART_ADD_TO_CART_ERROR,
    data,
});

export const externalCartAddToCartClearError = (data) => ({
    type: externalCartActionTypes.EXTERNALCART_ADD_TO_CART_CLEAR_ERROR,
    data,
});

export const externalCartUpdateDTW = (data) => ({
    type: externalCartActionTypes.EXTERNALCART_UPDATE_DTW,
    data,
});

export const externalCartUpdateDTWError = (data) => ({
    type: externalCartActionTypes.EXTERNALCART_UPDATE_DTW_ERROR,
    data,
});

export const externalCartDeleteItem = (data) => ({
    type: externalCartActionTypes.EXTERNALCART_DELETE_ITEM,
    data,
});

export const externalCartDeleteItemError = (data) => ({
    type: externalCartActionTypes.EXTERNALCART_DELETE_ITEM_ERROR,
    data,
});

export const externalCartUpdateTip = (data) => ({
    type: externalCartActionTypes.EXTERNALCART_UPDATE_TIP,
    data,
});

export const externalCartUpdateTipError = (data) => ({
    type: externalCartActionTypes.EXTERNALCART_UPDATE_TIP_ERROR,
    data,
});
